import { genOnFieldValueChange } from './onFieldValueChange';
import { generatorLatest } from './utils/generatorLatest';
export const genGetMultiFieldsRes = form => keys => {
  const fieldStates = keys.map(key => form.getFieldState(key));
  return {
    fieldStates,
    fieldValues: fieldStates.map(s => s === null || s === void 0 ? void 0 : s.value)
  };
};
export const genOnMultiFieldsValueChange = ($, form) => {
  const onMultiFieldsValueChange = (keys, cb) => {
    const generatorCb = generatorLatest(cb);
    const getMultiFieldsRes = genGetMultiFieldsRes(form);

    const wrappedCb = ({
      triggerFieldState
    }) => {
      generatorCb({ ...getMultiFieldsRes(keys),
        triggerFieldState
      });
    };

    const onFieldValueChange = genOnFieldValueChange($, form);
    keys.forEach(key => {
      onFieldValueChange(key, triggerFieldState => wrappedCb({
        triggerFieldState
      }));
    });
  };

  return onMultiFieldsValueChange;
};
//# sourceMappingURL=es/Form/extendsEffects/onMultiFieldsValueChange.js.map